import './MsgBox.css';

const MsgBox = ({ show, msg, onConfirm, onCancel }) => {
    const option = {
        title: '提示',
        text: '',
        confirmText: '确定',
        cancelText: '',
    }
    if (!show) {
        return null
    }
    if (typeof msg === "string") {
        option.text = msg
    } else if (typeof msg === "object" && msg !== null) {
        Object.assign(option, msg)
    }

    const cancelBtn = option.cancelText ? (<div onClick={onCancel} className="MsgBoxBtn">{option.cancelText}</div>) : null;
    const confirmBtn = option.confirmText ? (<div onClick={onConfirm} className="MsgBoxBtn">{option.confirmText}</div>) : null;

    return (
        <div className="MessageBox">
            <div className="MsgBoxContent SectionBg">
                <div className="MsgBoxHeader">
                    {option.title}
                </div>
                <div className="MsgBoxBody">
                    {option.text}
                </div>
                <div className="MsgBoxFooter">
                    {cancelBtn}
                    {confirmBtn}
                </div>
            </div>
        </div>
    )
}

export default MsgBox
